export const DEFAULT_API_TIME_OUT = 1000 * 30

// 菜单类型 0：目录 1：菜单 2：按钮
export const MENU_TYPE_DIRECTORY = 0
export const MENU_TYPE_MENU_URL = 1
export const MENU_TYPE_BUTTON = 2
